module.exports = __webpack_public_path__ + "static/GideonA-d29a67b9c991279867498b39e384512f.gif";